import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';
import { getDecodedFirebaseConfig } from './firebaseConfig';

export const initFirebase = (): firebase.messaging.Messaging | null => {
  const firebaseConfig = getDecodedFirebaseConfig();

  if (!firebaseConfig) {
    console.error('Firebase config is missing or invalid.');
    return null;
  }

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

  const messaging = firebase.messaging();
  if (!messaging) {
    console.error('Firebase messaging is not initialized.');
    return null;
  }

  return messaging;
};
